import { Plus } from '@phosphor-icons/react';
import translations from '../../../translations';
import ButtonPrimary from '../../buttons/ButtonPrimary';
import ButtonDefault from '../../buttons/ButtonDefault';
import { ExIcon } from '@boomi/exosphere';
import Boominaut from './Boominaut';

interface Props {
    onNewFlowClick: () => void;
    onImportFlowClick: () => void;
}

const GettingStarted = ({ onNewFlowClick, onImportFlowClick }: Props) => (
    <div className="getting-started">
        <Boominaut />
        <h2 className="getting-started-title">{translations.HOME_getting_started_header}</h2>
        <p className="getting-started-content">
            {translations.HOME_getting_started_content}{' '}
            <a
                href="https://help.boomi.com/docs/Atomsphere/Flow/Topics/Setting_up_and_managing_flows/c-flo-Setting-up-Overview_98cb7642-0e91-49b3-845a-c28f7451f134"
                target="_blank"
                rel="noopener noreferrer"
            >
                {translations.HOME_getting_started_content_end}
            </a>
        </p>
        <div className="getting-started-buttons">
            <ButtonPrimary onClick={onNewFlowClick}>
                <Plus className="new-flow-icon" /> {translations.HOME_new_flow}
            </ButtonPrimary>
            <ButtonDefault onClick={onImportFlowClick} title={translations.HOME_import_flow}>
                <ExIcon icon="Upload" label={translations.HOME_import_flow} />
                <span className="button-text">{translations.HOME_import_flow}</span>
            </ButtonDefault>
        </div>
    </div>
);

export default GettingStarted;
